const methodNames = ['focus', 'blur', 'resetValidation', 'validate', 'select']
const methods = {}
for (const name of methodNames) {
  methods[name] = function () {
    const input = this.$refs.input
    return input && input[name] && input[name](...arguments)
  }
}
const getterNames = ['focused', 'editable', 'hasValue', 'hasError', 'computedErrorMessage', 'computedCounter']
const getters = {}
for (const name of getterNames) {
  getters[name] = {
    get () {
      const input = this.$refs.input
      return input && input[name]
    }
  }
}
export default {
  computed: {
    ...getters
  },
  methods: {
    ...methods
  }
}
